export enum HeaderEnum {
  LINKSUPPORT = 'https://suporte.veilingnet.com.br/plugins/formcreator/front/formdisplay.php?id=68',
  LINKBUSINESSCONTACTS = 'https://veiling.com.br/contatos-comerciais',
}
